<template>
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :show-close="true"
    :title="$t('trailer.exportNotice')"
    :visible.sync="dialogSelectExport"
    width="500px"
    @close="clearForm"
  >
    <el-form
      ref="selectForm" :model="selectForm" class="demo-selectForm"
      label-position="top"
    >
      <el-form-item
        :label="$t('trailer.selectExportContentIncludesImages')"
        :rules="{
          required: true,
          message: $t('placeOrder.pleaseInput'),
          trigger: ['blur']
        }"
        prop="withImage"
        style="width: 100%"
      >
        <el-radio-group v-model="selectForm.withImage">
          <el-radio :label="true">{{ $t('trailer.withImages') }}</el-radio>
          <el-radio :label="false">{{ $t('trailer.withoutImages') }}</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div style="text-align: right; margin: 15px 0">
      <el-button size="small" @click="dialogSelectExport = false">{{ $t('GlobalSetObj.Cancelar') }}
      </el-button>
      <el-button size="small" type="primary" @click="comfire">{{ $t('collectionCenter.CheckItOutNow') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { goResourceTaskList } from '@/utils/goExportList';
import { collectProblemExport } from '@/api/lanshou';

export default {
  name: 'OrderNumberExport',
  data() {
    return {
      dialogSelectExport: false,
      selectForm: {
        withImage: ''
      },
      activeName: '0',
      queryParam: {}
    };
  },
  methods: {
    handleSelectExportOpen(val) {
      this.queryParam = val;
      this.dialogSelectExport = true;
    },
    clearForm() {
      this.selectForm.withImage = '';
    },
    comfire() {
      this.$refs['selectForm'].validate((valid) => {
        if (valid) {
          this.queryParam.withImage = this.selectForm.withImage;
          // 导出列表信息
          collectProblemExport(this.queryParam).then((res) => {
            if (res.code === 200) {
              this.dialogSelectExport = false;
              goResourceTaskList();
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped></style>
